module.exports = __webpack_public_path__ + "static/media/the-game-afl-2026-early-bird.fe4ecb6e.jpg";